import React, {useState} from 'react';
import L, {LatLngExpression, LatLngTuple, latLngBounds, divIcon} from 'leaflet';
import {
	MapContainer,
	Marker,
	TileLayer,
	Popup,
	useMapEvent,
	useMapEvents,
	useMap,
	Circle,
	Pane,
	LayersControl
} from 'react-leaflet';
import RoutineMachine from './RoutingMachine';
import HeaderWithIcons from '@components/app/HeaderWithIcons';
import {useTheme, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';
//@ts-ignore
import markerParking from '../assets/icons/marker_parking.svg';
// @ts-ignore
// import markerParkingLots from '../assets/icons/marker_parking_lots.svg';
// @ts-ignore
import markerLive from '../assets/icons/marker_live.svg';
// @ts-ignore
import markerShrine from '../assets/icons/marker_shrine.svg';
import {useParams} from 'react-router-dom';
import {TLocations} from '@context/MapContext';
import {layersMap} from '../components/Map';
import Control from 'react-leaflet-custom-control';

const {BaseLayer, Overlay} = LayersControl;
let MarkerParkingIcon = L.icon({
	iconUrl: markerParking,
	// iconRetinaUrl: markerRetina,
	// shadowUrl: markerShadow
	iconSize: [30, 30]
});
let MarkerLiveIcon = L.icon({
	iconUrl: markerLive,
	iconSize: [30, 30]
});
let MarkerShrineIcon = L.icon({
	iconUrl: markerShrine,
	iconSize: [30, 30]
});
export default function ParkingRoute() {
	const {places, start, stop} = useParams();
	let locations: TLocations = {
		places: [],
		start: [],
		stop: []
	};
	locations['places'] = places!.split('_');
	locations['start'] = start!.split(',').map(Number);
	locations['stop'] = stop!.split(',').map(Number);
	const theme = useTheme();
	const {t} = useTranslation();
	const [map, setMap] = useState<L.Map>();
	const ZoomControl = () => {
		const zoomIn = (e: { preventDefault: () => void; }) => {
			e.preventDefault();
			map?.setZoom(map?.getZoom() + 1);
		};
		const zoomOut = (e: { preventDefault: () => void; }) => {
			e.preventDefault();
			map?.setZoom(map?.getZoom() - 1);
		};
		return (
			<div className="flex flex-col items-center bg-[#ffffffe6] p-1 text-center text-lg text-black rounded font-bold">
				<Typography
					component="div"
					className="w-7 h-7 text-black border-b border-gray-300"
					title="Zoom in"
					role="button"
					aria-label="Zoom in"
					onClick={zoomIn}
					sx={{
						color: () => '#000',
						fontSize: (theme) => theme.typography.fontSize + 5
					}}
				>
					+
				</Typography>
				<Typography
					component="div"
					className="w-7 h-7 text-black pt-1"
					title="Zoom out"
					role="button"
					aria-label="Zoom out"
					onClick={zoomOut}
					sx={{
						color: () => '#000',
						fontSize: (theme) => theme.typography.fontSize + 5
					}}
				>
					−
				</Typography>
			</div>
		);
	};
	return (
		<>
			<div className="w-full h-full flex flex-col space-y-2">
				<HeaderWithIcons title={t('parking.directions_to_destination')}/>
				<MapContainer
					id="mapId"
					zoom={14}
					zoomControl={false}
					scrollWheelZoom={true}
					doubleClickZoom={true}
					center={[36.2884, 59.6157]}
					className="mapRoute w-full h-1/2"
					// @ts-ignore
					whenReady={({target: map}) => {
						setTimeout(() => {
							setMap(map);
							// setMapLoaded(true);
							// can use `map.getBound()` without error here
							// map.flyTo([36.27819926, 59.61723447], map.getZoom());
						}, 100);
					}}
				>
					<Control prepend={true} position="topleft">
						<ZoomControl/>
					</Control>
					<LayersControl position="topright">
						{/*<LayersControl.BaseLayer checked name="Map">*/}
						{/*	<TileLayer*/}
						{/*		attribution="Rezvan"*/}
						{/*		url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"*/}
						{/*	/>*/}
						{/*</LayersControl.BaseLayer>*/}
						{layersMap.map((layer, index) => {
							return (
								<BaseLayer
									key={index}
									checked={index === 0}
									name={t(`parking.layers.${layer.name}`)}
								>
									<TileLayer
										attribution={layer.attribution}
										url={layer.url}
									/>
								</BaseLayer>
							);
						})}
					</LayersControl>
					<Marker
						key={'parking_marker'}
						position={[locations['start'][0], locations['start'][1]]}
						draggable={false}
						// eventHandlers={eventHandlers}
						// ref={markerRef}
						icon={locations['places'][0] == 'shrine' ? MarkerShrineIcon : locations['places'][0] == 'live' ? MarkerLiveIcon : MarkerParkingIcon}
					></Marker>
					<Marker
						key={'parking_marker'}
						position={[locations['stop'][0], locations['stop'][1]]}
						draggable={false}
						// eventHandlers={eventHandlers}
						// ref={markerRef}
						icon={locations['places'][1] == 'shrine' ? MarkerShrineIcon : locations['places'][1] == 'live' ? MarkerLiveIcon : MarkerParkingIcon}
					></Marker>
					<RoutineMachine locations={locations}/>
				</MapContainer>
				<div id={'path-results'}
				     className={`w-full ${theme.palette.mode === 'light' ? 'light bg-gray-100' : 'dark bg-gray-600'}`}></div>
			</div>
		</>
	);
};

